<template>
  <div class="client-container task-statistics-container">
    <div
      :style="{ overflow: 'hidden' }"
      class="table-search-container"
    >
      <bread-crumb :style="{ float: 'left' }" />

      <div :style="{ float: 'right' }">
        <a-select
          default-value="2020年"
          style="width: 140px;marginRight:10px;"
          @change="handleChangeYear"
        >
          <a-select-option
            v-for="item in yearData"
            :key="item.id"
            :value="item.id"
          >
            {{ item.value }}
          </a-select-option>
        </a-select>
        <a-select
          :default-value="mounthData[mounth].value"
          style="width: 140px"
          @change="handleChangeMounth"
        >
          <a-select-option
            v-for="item in mounthData"
            :key="item.id"
            :value="item.id"
          >
            {{ item.value }}
          </a-select-option>
        </a-select>
      </div>
    </div>
    <div>
      <a-row
        :gutter="16"
        type="flex"
      >
        <a-col :span="8">
          <div class="card-style">
            <div class="card-title">
              任务数量
            </div>
            <div class="card-body">
              <div id="numId" />
            </div>
          </div>
        </a-col>
        <a-col :span="8">
          <div class="card-style">
            <div class="card-title">
              类型占比
            </div>
            <div class="card-body">
              <div id="typeId" />
            </div>
          </div>
        </a-col>
        <a-col :span="8">
          <div class="card-style">
            <div class="card-title">
              任务进度
            </div>
            <div class="card-body">
              <div id="progressId" />
            </div>
          </div>
        </a-col>
      </a-row>
      <a-row class="row-margin">
        <a-col :span="24">
          <div class="card-style">
            <div class="card-title">
              个人进度
              <a-select
                v-if="companyData.length>0"
                :default-value="companyData[0].team_name"
                style="width: 140px;marginRight:10px;"
                @change="handleChangeCompany"
              >
                <a-select-option
                  v-for="item in companyData"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.team_name }}
                </a-select-option>
              </a-select>
            </div>

            <div class="card-body">
              <div class="card-tabs">
                <a-tabs
                  v-if="tabDatas.length>0"
                  :default-active-key="tabDatas[0].id"
                  @change="handleTab"
                >
                  <a-tab-pane
                    v-for="item in tabDatas"
                    :key="item.id"
                    :tab="item.name"
                  />
                </a-tabs>
              </div>
              <div id="personalId" />
            </div>
          </div>
        </a-col>
      </a-row>
    </div>
  </div>
</template>
<script>
let chart;
let chart1;
let chart2;
let chart3;
import { Chart, registerShape } from '@antv/g2';
import { DataView } from '@antv/data-set';
import { mounthData, data, testData } from './data/index';
export default {
  data() {
    return {
      yearData: [{ id: 1, value: '2020年' }],
      mounthData,
      companyData: [],
      tabDatas: [],
      data: [{}],
      data1: [{}],
      data2: [{}],
      data3: [{}],
      mounth: 0,
      chartDataLast: [],
    };
  },
  created(){
    // 获取当前月份
    let date=new Date();
    let key=date.getMonth();
    this.mounth=key;

  },
  async mounted() {
    // 获取数据
    await this.getData({time: `2020${this.mounthData[this.mounth].id}`});


    const e = document.createEvent('Event');
    e.initEvent('resize', true, true);
    window.dispatchEvent(e);
  },
  methods: {
    // 获取数据
    async getData(params) {
      let result = await this.$http.post(
        '/statistics/getWorReportInfosByMonth',
        params
      );

      // result = {
      //   data: testData,
      // };
      if (result.data.status === 1) {
        if(result.data.data.team_list.length>0){
          // 获取公司
          this.companyData=result.data.data.team_list;
          // 获取tab
          this.tabDatas=result.data.data.team_list[0].service_provider_list;
        }else{
        }
        // 表1  表2  表3
        if(result.data.data.service_list.length>0){
          let temp=result.data.data.service_list.filter((item)=>item.plan_num !==0);
          this.data=temp;
          let total=0;
          temp.forEach((item)=>{
            total+=item.plan_num;
          });
          this.data1=temp.map((item)=>{
            const percent = Math.round(item.plan_num/total*100)/100;
            console.log(total, item.plan_num, percent);
            return {
              // percent,
              ...item,
            };
          });
          console.log('getData -> this.data1', this.data1);
          let temp1=temp.map((item)=>{
            return {
              type: '未完成',
              name: item.name,
              value: item.todo_num,
            };
          });
          let temp2=temp.map((item)=>{
            return {
              type: '已完成',
              name: item.name,
              value: item.done_num,
            };
          });
          this.data2=[...temp1, ...temp2];
        }else{
          this.data=[{}];
          this.data1=[];
          this.data2=[{}];
        }

        // 表4
        if(result.data.data.team_list.length>0){
          this.chartDataLast=result.data.data.team_list;
          let newData=result.data.data.team_list[0].service_provider_list[0].promoter_list;
          let temp3=newData.map((item)=>{
            return {
              type: '总量',
              name: item.name,
              value: item.plan_num,
            };
          });
          let temp4=newData.map((item)=>{
            return {
              type: '已完成',
              name: item.name,
              value: item.done_num,
            };
          });
          this.data3=[...temp3, ...temp4];
        }else{
          this.data3=[{}];
        }
        // 获取任务数量
        await this.getTasknum();
        // 类型占比
        await this.getType();
        // 任务进度
        await this.getTaskprogress();
        // 个人进度
        await this.getPersonal();
      }
    },
    // 任务数量
    getTasknum() {
      console.log(2222);
      chart = new Chart({
        container: 'numId',
        autoFit: true,
        height: 220,
      });
      chart.data(this.data);
      chart.scale({
        name: {
          nice: true,
        },
        plan_num: {
          nice: true,
          alias: '任务数量',
        },
      });
      chart.coordinate().transpose();
      chart.tooltip({
        showMarkers: false,
      });
      chart.interaction('active-region');
      chart
        .interval()
        .position('name*plan_num')
        .color('#46D3DD')
        .size(20);
      chart.render();
    },
    // 类型占比
    getType() {
      console.log(33333);
      const sliceNumber = 0.01;
      // 自定义 other 的图形
      registerShape('interval', 'slice-shape', {
        draw(cfg, container) {
          const points = cfg.points;
          let path = [];
          path.push(['M', points[0].x, points[0].y]);
          path.push(['L', points[1].x, points[1].y - sliceNumber]);
          path.push(['L', points[2].x, points[2].y - sliceNumber]);
          path.push(['L', points[3].x, points[3].y]);
          path.push('Z');
          path = this.parsePath(path);
          return container.addShape('path', {
            attrs: {
              fill: cfg.color,
              path,
            },
          });
        },
      });
      const dv = new DataView();
      dv.source(this.data1).transform({
        type: 'percent',
        field: 'plan_num',
        dimension: 'name',
        as: 'percent',
      });
      chart1 = new Chart({
        container: 'typeId',
        autoFit: true,
        height: 220,
      });
      // chart1.data(this.data1);
      console.log('getType -> dv.rows', dv.rows);
      chart1.data(dv.rows);
      chart1.coordinate('theta', {
        radius: 0.75,
        innerRadius: 0.6,
      });
      chart1.scale('percent', {
        formatter: (val) => {
          val = (val * 100).toFixed(2) + '%';
          return 'val';
        },
      });
      chart1.tooltip({
        showTitle: false,
        showMarkers: false,
      });
      chart1
        .interval()
        .adjust('stack')
        .position('plan_num')
        .color('name')
        .label('percent', (percent) => {
          return {
            content: (data) => {
              return `${data.name}: ${(data.percent * 100).toFixed(2) }%`;
            },
          };
        })
        .tooltip('name*percent', (name, percent) => {
          percent =     (percent * 100).toFixed(2) + '%';

          return {
            name: name,
            value: percent,
          };
        })
        .shape('slice-shape');
      chart1.legend({
        marker: {
          symbol: 'square',
        },
      });
      chart1.render();
    },
    // 任务进度
    getTaskprogress() {
      console.log(44444);
      chart2 = new Chart({
        container: 'progressId',
        autoFit: true,
        height: 220,
      });
      chart2.data(this.data2);
      // 度量
      chart2.scale('value', {
        nice: true,
      });
      // 提示信息
      chart2.tooltip({
        shared: true,
        showMarkers: false,
      });
      chart2
        .interval()
        .position('name*value')
        .color('type', ['#869cf7', '#46D3DD'])
        .adjust('stack')
        .size(20);;
      chart2.interaction('active-region');
      chart2.render();
    },

    // 个人进度
    getPersonal() {
      console.log(55555);
      chart3 = new Chart({
        container: 'personalId',
        autoFit: true,
        height: 220,
      });
      chart3.data(this.data3);
      chart.scale('name', {
        type: 'linear',
        tickInterval: 50,
      });
      chart3.scale('value', {
        nice: true,
      });
      chart3.tooltip({
        showCrosshairs: true,
        shared: true,
      });
      chart3
        .area()
        .adjust('stack')
        .position('name*value')
        .color('type', ['l(270) 0:#ffffff 0.5:#bbc9ff 1:#869cf7', 'l(270) 0:#ffffff 0.5:#bee8ef 1:#46D3DD'])
        .shape('smooth')
      ;
      chart3
        .line()
        .adjust('stack')
        .position('name*value')
        .color('type', ['#869cf7', '#46D3DD'])
        .tooltip(false)
        .shape('smooth');
      chart3.interaction('element-highlight');
      chart3.render();
    },
    // 选择年份
    handleChangeYear(year) {
      console.log('year', year);
    },
    // 选择月份
    async handleChangeMounth(m) {
      console.log('chart2', chart2);
      console.log('handleChangeMounth -> m', m);
      await this.getData({time: `2020${m}`});

      chart.changeData(this.data);
      chart.onResize();
      console.log('handleChangeMounth -> this.data1', this.data1);

      if(this.data1.length === 0){

        chart1.changeData([{}]);
        chart1.onResize();
      }else{
        const dv = new DataView();
        dv.source(this.data1).transform({
          type: 'percent',
          field: 'plan_num',
          dimension: 'name',
          as: 'percent',
        });
        chart1.changeData(dv.rows);
        chart1.onResize();
      }

      chart2.changeData(this.data2);
      chart2.onResize();
      chart3.changeData(this.data3);
      chart3.onResize();

    },
    // 选择公司
    handleChangeCompany(c) {
      console.log('handleChangeCompany -> c', c);
      let data=this.chartDataLast.find((item)=>item.id===c);
      console.log('handleChangeCompany -> data', data);
      this.tabDatas=data.service_provider_list;
      let newData=this.tabDatas[0].promoter_list;
      let temp3=newData.map((item)=>{
        return {
          type: '总量',
          name: item.name,
          value: item.plan_num,
        };
      });
      let temp4=newData.map((item)=>{
        return {
          type: '已完成',
          name: item.name,
          value: item.done_num,
        };
      });
      this.data3=[...temp3, ...temp4];
      chart3.changeData(this.data3);
      chart3.onResize();
    },
    // 选择tab
    handleTab(key) {
      console.log('handleTab -> key', key);
      let data=this.tabDatas.find((item)=>item.id===key);
      let newData=data.promoter_list;
      let temp3=newData.map((item)=>{
        return {
          type: '总量',
          name: item.name,
          value: item.plan_num,
        };
      });
      let temp4=newData.map((item)=>{
        return {
          type: '已完成',
          name: item.name,
          value: item.done_num,
        };
      });
      this.data3=[...temp3, ...temp4];
      chart3.changeData(this.data3);
      chart3.onResize();
    },
  },
};
</script>
<style lang="scss" scoped>
.task-statistics-container {
  .card-style {
    background: #fff;
    border-radius: 10px;
    .card-title {
      height: 56px;
      line-height: 56px;
      font-size: 16px;
      font-weight: 500;
      color: rgba(42, 41, 71, 1);
      padding-left: 24px;
      padding-right: 24px;
    }
    .card-body {
      padding:20px;
      padding-top: 0;
      .card-tabs {
        margin-bottom: 20px;
        margin-left: 46px;
      }
    }
  }
  .row-margin {
    margin-top: 20px;
  }
}
</style>